export default __webpack_public_path__ + "static/media/pokedex-render-1024.638276ab.png";